export default "__VITE_ASSET__Bycv$6Sr__"